'use strict';

const { normalizeYearlyMonths } = require('./yearlyTrendUtils');

function buildYearlyPepTrendMetrics(rows) {
    return [
        { title: 'OEE (%)', loss: false, months: normalizeYearlyMonths(rows, 'oee') },
        { title: 'Availability (%)', loss: false, months: normalizeYearlyMonths(rows, 'availability') },
        { title: 'Productivity (%)', loss: false, months: normalizeYearlyMonths(rows, 'productivity') },
        { title: 'Quality Loss (%)', loss: true, months: normalizeYearlyMonths(rows, 'qloss') },
        { title: 'Technical Loss (%)', loss: true, months: normalizeYearlyMonths(rows, 'tloss') },
        { title: 'Organization Loss (%)', loss: true, months: normalizeYearlyMonths(rows, 'oloss') },
    ];
}

module.exports = { buildYearlyPepTrendMetrics };
